import React from 'react';
import Anchor from '../components/general/anchor.component';
import VideoBehindText from '../components/video-image-background/video-behind-text.component';
//import tw from "twin.macro";

const ContactPage = () => (
   <VideoBehindText mainText="Contact" url="bg.jpg">
      <div className="grid place-items-center">
         <div>
            <div className="pt-8">
               <span className="pl-4">Drop me an email:</span>
               <Anchor url="mailto:contact@ethanloch.com" text="contact@ethanloch.com" />
            </div>
            <div className="pt-4">
               <span className="pl-4">Subscribe to my mailing list:</span>
               <Anchor url="https://mailchi.mp/6ab6431253ac/ethandavidloch" text="MailChimp mailing list page" />
            </div>
            <div className="pt-4">
               <span className="pl-4">My YouTube Channel is here:</span>
               <Anchor url="https://www.youtube.com/channel/UC4Y-I58cmjaSAXTaJoVI_ZQ" text="Ethan David Loch" />
            </div>
            <div className="pt-4">
               <span className="pl-4">View my posts on Reddit:</span>
               <Anchor url="https://www.reddit.com/user/ethanloch" copytext />
            </div>
            <div className="py-4">
               <span className="pl-4">SoundCloud audio here:</span>
               <Anchor url="https://soundcloud.com/ethandavidloch" copytext />
            </div>
         </div>
      </div>
   </VideoBehindText>
);

export default ContactPage;